
import {
    Row,
    Col,
    Card,
    CardBody,
    FormGroup,
    Label,
    Input,
    Container,
    FormFeedback,
    Form,
} from "reactstrap"

import React from "react"
import SearchSelectBox from "../../../components/SearchSelectBox"
import { useTranslation } from "react-i18next"
import AddMoreInput from "../../../components/AddMoreInput"
import AddMoreInputV2 from "../../../components/AddMoreInputV2"
import moment from "moment/moment"
import useAllowedFields from "../../../hooks/useAllowedFields"
import FIELDS, { ADDITIONAL_FIELDS, AQUSITION_FIELDS, MEDIA_FIELDS, ROLE3_FIELDS } from "./CONSTANT"
import ChooseImage from "../../../components/ChooseImage"
import { FieldInput } from "../../../components/FieldInput"




export default function EmployeeForm({validation}){


    return(
        <Row>
            <Col md={12}>
                <Card>
                    <CardBody>
                        <Row>
                            {MEDIA_FIELDS.map(f => (
                                <FieldInput key={f.key} f={f} validation={validation} />
                            ))}
                        </Row>
                    </CardBody>
                </Card>
            </Col>
            <Col md={12}>
                <Card>
                    <CardBody>
                        <Row>
                            {ADDITIONAL_FIELDS.map(f => (
                                <FieldInput key={f.key} f={f} validation={validation} />
                            ))}
                        </Row>
                    </CardBody>
                </Card>
            </Col>
        </Row>
    )
}